// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"443":"ef11ed45","985":"af7eaaef"}[chunkId] + ".chunk.js";
};